import { IAuth } from "..";
import { ServiceCaller, methods } from '../../../../libs/service-caller'

const _serviceCaller = new ServiceCaller(process.env.VUE_APP_API);

export class IdentityAuth extends IAuth {
    constructor() {
        super();
    }

    async registerWithEmailAndPassword() {
    }

    async loginWithEmailAndPassword(emailAddress, password) {
        let request = {
            username: emailAddress,
            password: password
        }

        try
        {
            const response = await _serviceCaller.call(methods.post, "Authorisation/Login", request);
            return response;
        }
        catch(err) {
            return null;
        }
    }

    async verifyLogin() {
        try
        {
            await _serviceCaller.call(methods.get, "Connection");
            return true;
        }
        catch(err) {
            console.log(err);
            return false;
        }
    }
}